import { COLOR, CosunoLogo, Spinner } from '@cosuno/cosuno-ui';

import { ErrorBoundary } from '~/shared/components/ErrorBoundary';
import HtmlHeadTags from '~/shared/components/HtmlHeadTags';

import { PremiumLogo } from './PremiumLogo';
import {
  Heading,
  LeftPanel,
  LoadingWrapper,
  RightPanel,
  RightPanelContentWrapper,
  RightPanelLogoWrapper,
  SplitScreenWrapper,
} from './Styles';

interface Props {
  title?: string;
  children: React.ReactNode;
  isPremium?: boolean;
  renderOnLeftPanel?: () => React.ReactNode;
}

export const SplitScreenUnauthenticatedPage: React.FC<Props> = ({
  title,
  children,
  isPremium,
  renderOnLeftPanel,
  ...props
}) => (
  <SplitScreenWrapper {...props}>
    <ErrorBoundary>
      <HtmlHeadTags title={title ?? null} themeColor={COLOR.brand} />
      <LeftPanel>
        {isPremium ? <PremiumLogo /> : <CosunoLogo color={COLOR.white} width={220} />}
        {renderOnLeftPanel && renderOnLeftPanel()}
      </LeftPanel>
      <RightPanel>
        <RightPanelContentWrapper>
          <RightPanelLogoWrapper>
            {isPremium ? <PremiumLogo /> : <CosunoLogo color={COLOR.brand} width={200} />}
          </RightPanelLogoWrapper>
          {children}
        </RightPanelContentWrapper>
      </RightPanel>
    </ErrorBoundary>
  </SplitScreenWrapper>
);

export const SplitScreenUnauthenticatedLoadingPage: React.FC<Pick<Props, 'title'>> = ({
  title,
}) => (
  <SplitScreenUnauthenticatedPage title={title}>
    <LoadingWrapper>
      <Spinner size={56} />
      <Heading>{title}</Heading>
    </LoadingWrapper>
  </SplitScreenUnauthenticatedPage>
);
